module.exports = __webpack_public_path__ + "static/important-renovation-75032e67f5b6bbf58a8e1526eede674f.jpg";